<template>
  <div class="bg position-relative">
    <div class="left-image"></div>
    <div class="right-image"></div>


    <div class="bc">
      <img class="img_1" src="/img/image/home/t_11.png" loading="lazy" alt="滿香脆其他服務">
      <div style="height: 36px;"/>
      <div class="row no-gutters  px-lg-6 px-md-6 px-sm-6 ">
        <div class="col-lg-7 col-sm-12">
          <div class="row no-gutters">
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/customized_icon.png"
                            content="企業禮盒</br>客製化需求" defaultContent="企業禮盒客製化需求"/>
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/gift_icon.png" content="送禮需求"/>
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/dishes_icon.png" content="餐廳合作入菜"/>
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/store_icon.png" content="店內合作販賣"/>
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/order_icon.png" content="大量訂購需求"/>
            <CustomIconInfo class="col-sm-6 col-12" imageSrc="/img/image/icon/cooperate_icon.png" content="其他合作需求"/>
          </div>
          <div class="row no-gutters align-items-center justify-content-lg-start justify-content-center">
            <div class="line_text text-white">歡迎洽詢</div>
            <div style="width: 18px;"/>
            <button type="button" class="btn btn_style" @click="clickLine">
              <div class="row no-gutters align-items-center justify-content-center ">
                  <span class="button_text text-white">
                   官方 LINE
                  </span>
                <div class="button_space"/>
                <img class="button_icon" src="/img/image/icon/arrow.png" loading="lazy" alt>
              </div>
            </button>

          </div>
        </div>
        <div class="col-5"/>
      </div>
      <div style="height: 50px;"/>
    </div>
  </div>
</template>

<script>
import CustomIconInfo from "../components/CustomIconInfo";
import {isEmpty} from "../../util/helpers";

export default {
  name: "Stage_7",
  components: {CustomIconInfo,},
  computed: {
    settingData() {
      return this.$store.getters.getSettingData;
    },
    lineUrl() {
      let val = this.settingData.data.url_line;
      return isEmpty(val) ? '' : val;
    },
  },
  methods: {
    clickLine() {
      let url = this.lineUrl;
      window.open(url, '_blank');
    },
  },
}
</script>

<style lang="scss" scoped>


.bg {

}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  //text-align: center;
}

@media (max-width: 992px) {
  .bc {
    text-align: center;
  }
}

.left-image, .right-image {
  position: absolute;
  top: 0;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.left-image {
  left: 0;
  width: 100%;
  background-image: url('/img/image/background/bg_s7_1.png');
  //clip-path: polygon(0 0, 100% 0%, 85% 100%, 0% 100%); /* 左側圖片的梯形 */
  z-index: -1;
}

.right-image {
  right: 0;
  width: 44%;
  background-image: url('/img/image/background/bg_s7_2.png');
  clip-path: polygon(22% 0%, 100% 0%, 100% 100%, 0% 100%); /* 右側圖片的梯形 */
}

@media (max-width: 992px) {
  .right-image {
    width: 0;
  }
}


// 文字 認識更多滿香脆
.img_1 {
  padding-top: 42px;
  padding-left: 87px;
  max-width: 532px;
  width: 532px;
  height: auto;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 992px) {
  .img_1 {
    padding-left: 0px;
    width: 53vw;
  }
}

@media (max-width: 576px) {
  .img_1 {
    width: 55vw;
  }
}

@media (max-width: 360px) {
  .img_1 {
    width: 88vw;
  }
}


.line_text {
  font-family: Noto Sans TC;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: left;
}

@media (max-width: 992px) {
  .line_text {
    font-size: 18px;
  }
}


.button_text {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
}

@media (max-width: 576px) {
  .button_text {
    font-size: 18px;
  }
}


.button_space {
  width: 16px;
}

@media (max-width: 576px) {
  .button_space {
    width: 0;
    height: 0;
  }
}


.btn_style {
  width: 230px;
  height: 56px;
  background-color: #06C655;
  border-radius: 10px;
  border: 4px solid white;
  box-shadow: 0 5px 10px 0 #00000054;
  padding: 0;
  margin: 0;
}

@media (max-width: 576px) {
  .btn_style {
    width: 120px;
    height: 40px;
  }
}


.button_icon {
  width: 40px;
  height: 40px
}

@media (max-width: 576px) {
  .button_icon {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}

</style>
